import React from "react";
import { PalletsTable } from "./PalletsTable";

export const ListadoPallets = (props) => {
    const { pallets = [], setPallets, modoLectura } = props;

    const ActualizarRecepcionPallet = (id, recibido) => {
        const updatedPallets = [...pallets];
        const index = updatedPallets.findIndex((pallet) => pallet.id === id);
        updatedPallets[index] = {
            ...updatedPallets[index],
            recibido_bodega: recibido,
        };
        setPallets(updatedPallets);
    };

    const MarcarTodoRecibido = () => {
        const updatedPallets = pallets.map((pallet) => ({
            ...pallet,
            recibido_bodega: true,
        }));
        setPallets(updatedPallets);
    };

    const MarcarTodoNoRecibido = () => {
        const updatedPallets = pallets.map((pallet) => ({
            ...pallet,
            recibido_bodega: false,
        }));
        setPallets(updatedPallets);
    };

    const ToggleRecibidos = (recibidos) => {
        if (recibidos) {
            MarcarTodoRecibido();
        } else {
            MarcarTodoNoRecibido();
        }
    };

    if (modoLectura) {
        const palletsAprobados = pallets.filter(
            (pallet) => pallet.recibido_bodega,
        );
        const palletsRechazados = pallets.filter(
            (pallet) => !pallet.recibido_bodega,
        );

        return (
            <React.Fragment>
                {palletsAprobados.length > 0 && (
                    <PalletsTable
                        pallets={palletsAprobados}
                        modoLectura={modoLectura}
                        headerText="Pallets aprobados"
                    />
                )}
                {palletsRechazados.length > 0 && (
                    <PalletsTable
                        pallets={palletsRechazados}
                        modoLectura={modoLectura}
                        headerText="Pallets rechazados"
                    />
                )}
            </React.Fragment>
        );
    }

    return (
        <PalletsTable
            pallets={pallets}
            ActualizarRecepcionPallet={ActualizarRecepcionPallet}
            ToggleRecibidos={ToggleRecibidos}
            modoLectura={modoLectura}
        />
    );
};
